/**
 * MIME types. Mirrors the backend `MimeType` enum (paxton_app/common/mime_type.py)
 * so FE and BE agree on content-type strings instead of scattering literals.
 */
export enum MimeType {
  JSON = 'application/json',
  PDF = 'application/pdf',
  CSV = 'text/csv',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  MARKDOWN = 'text/markdown',
  PLAIN_TEXT = 'text/plain',
  OCTET_STREAM = 'application/octet-stream',
  HTML = 'text/html',
  XML = 'application/xml',
}
